import axios from 'axios'
import router from '@/router'
import constList from '@/store/modules/ConstList'

const getDefaultState = () => {
  return {
    validations: {},
    isLoggedIn: false,
    loginUserId: 0,
    loginUserName: null,
    loginUserAdminStatus: false
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    validations(state) {
      return state.validations
    },
    isLoggedIn(state) {
      return state.isLoggedIn
    },
    loginUserName(state) {
      return state.loginUserName
    },
    loginUserId(state) {
      return state.loginUserId
    },
    loginUserAdminStatus(state) {
      return state.loginUserAdminStatus
    }
  },
  mutations: {
    setValidations(state, validations) {
      state.validations = validations
    },
    setIsLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    setLoginUserName(state, loginUserName) {
      state.loginUserName = loginUserName
    },
    setLoginUserId(state, loginUserId) {
      state.loginUserId = loginUserId
    },
    setLoginUserAdminStatus(state, loginUserAdminStatus) {
      state.loginUserAdminStatus = loginUserAdminStatus
    },
    resetState(state) {
      state = Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async login({ commit, getters }, { email, password, adminStatus }) {
      const params = new URLSearchParams()
      params.append('email', email)
      params.append('password', password)
      params.append('admin_status', adminStatus)

      try {
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.post(constList.apiUrl + 'auth/login', params)

        this.commit('resetState')
        this.commit('auth/resetState')
        this.commit('user/resetState')

        this.commit('auth/setLoginUserId', Number(data.id))
        this.commit('auth/setLoginUserName', data.name)
        this.commit('auth/setLoginUserAdminStatus', Boolean(Number(data.admin_status)))
        this.commit('auth/setIsLoggedIn', true)

        // 画像のDataURLを取得してStoreにセット
        this.dispatch('user/getPfDataURL')

        if (location.href.indexOf('admin') >= 0) {
          router.push('/admin')
        } else {
          router.push('/student')
        }
        return Promise.resolve()
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data, status } = error.response
        this.commit('auth/setValidations', data.validations)
        const rejectData = { data: data, status: status }
        return Promise.reject(rejectData)
      }
    },
    async logout({ commit, getters }) {
      try {
        await axios.post(constList.apiUrl + 'auth/logout')

        this.commit('resetState')
        this.commit('auth/resetState')
        this.commit('user/resetState')

        // 他のタブやウインドウを強制ログアウトするためのイベントを発火
        localStorage.setItem('logout', new Date().getTime())

        if (!router.currentRoute.path.toLowerCase().includes('/login')) {
          router.push(router.currentRoute.path.toLowerCase().includes('/admin') ? '/admin/login' : '/student/login')
        }
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
      }
    }
  }
}
